module.exports = __webpack_public_path__ + "fonts/icons.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/icons/fonts/icons.ttf
// module id = 1077
// module chunks = 0